module.exports = __webpack_public_path__ + "assets/projects/digital-data-collection/site.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/projects/digital-data-collection/site.jpg
// module id = 41
// module chunks = 0